// extracted by mini-css-extract-plugin
export default {"deadlineBadge":"DeadlineField_deadlineBadge__ZBuoH"};